<div class="tab-body">
  <div class="tab-head">
    <div>
      <h3>Payment Configuration</h3>
      <p>How payment links &amp; policies are generated for this client. One configuration per client.</p>
    </div>
    @if (exists()) {
      <p-tag value="Configured" severity="success" icon="pi pi-check-circle" />
    } @else {
      <p-tag value="Not configured" severity="warn" icon="pi pi-exclamation-circle" />
    }
  </div>

  @if (loading()) {
    <div class="state"><i class="pi pi-spin pi-spinner"></i>
      <p>Loading configuration…</p>
    </div>
  } @else {
    <form [formGroup]="form" class="menu-form pc-form">
      <div class="grid-3">
        <div class="field">
          <label>Payment Integration <span class="req">*</span></label>
          <p-select formControlName="paymentIntegrationId" [options]="integrationOptions()"
            optionLabel="label" optionValue="value" [filter]="true" filterBy="label"
            placeholder="Select integration" appendTo="body" />
          @if (form.get('paymentIntegrationId')?.touched && form.get('paymentIntegrationId')?.invalid) {
            <small class="err">Payment integration is required</small>
          }
        </div>
        <div class="field">
          <label>Currency</label>
          <p-select formControlName="currencyCode" [options]="currencyOptions" optionLabel="label"
            optionValue="value" appendTo="body" placeholder="Currency" />
        </div>
        <div class="field">
          <label>Payment Link Expiry (minutes)</label>
          <p-inputnumber formControlName="paymentLinkExpiryMinutes" [min]="0" [useGrouping]="false"
            placeholder="e.g. 60" />
        </div>
      </div>

      <div class="field">
        <label>Payment Description</label>
        <textarea class="form-textarea" rows="2" formControlName="paymentDescription"
          placeholder="Shown to the payer on the payment page"></textarea>
      </div>

      <div class="grid-2">
        <div class="field">
          <label>Payment Success URL</label>
          <input pInputText type="text" formControlName="paymentSuccessUrl"
            placeholder="https://…/success" />
          @if (form.get('paymentSuccessUrl')?.touched && form.get('paymentSuccessUrl')?.invalid) {
            <small class="err">Enter a valid URL (http/https)</small>
          }
        </div>
        <div class="field">
          <label>Payment Failure URL</label>
          <input pInputText type="text" formControlName="paymentFailureUrl"
            placeholder="https://…/failure" />
          @if (form.get('paymentFailureUrl')?.touched && form.get('paymentFailureUrl')?.invalid) {
            <small class="err">Enter a valid URL (http/https)</small>
          }
        </div>
      </div>

      <div class="switch-grid">
        <label class="switch-row">
          <p-toggleSwitch formControlName="allowPartialPayment" />
          <span>Allow partial payment</span>
        </label>
        <label class="switch-row">
          <p-toggleSwitch formControlName="allowExpiredPayment" />
          <span>Allow expired payment</span>
        </label>
        <label class="switch-row">
          <p-toggleSwitch formControlName="autoGeneratePaymentLink" />
          <span>Auto-generate payment link</span>
        </label>
        <label class="switch-row">
          <p-toggleSwitch formControlName="autoGeneratePolicy" />
          <span>Auto-generate policy <small>(on payment success)</small></span>
        </label>
        <label class="switch-row">
          <p-toggleSwitch formControlName="isActive" />
          <span>Active</span>
        </label>
      </div>

      <div class="modal-actions">
        @if (exists()) {
          <p-button label="Delete" icon="pi pi-trash" [outlined]="true" severity="danger"
            (onClick)="remove()" />
        }
        <p-button [label]="saving() ? 'Saving…' : (exists() ? 'Update Configuration' : 'Save Configuration')"
          icon="pi pi-check" (onClick)="save()" [disabled]="saving()" [loading]="saving()" />
      </div>
    </form>
  }
</div>
